export enum MapShape {
    CIRCLE = 'CIRCLE',
    RECTANGLE = 'RECTANGLE',
    POLYGON = 'POLYGON',
    POLYLINE = 'POLYLINE'
}
